<template>
  <div style="display: flex; gap: 30px; flex-wrap: wrap; margin: 20px 0">
    <!-- 对照组 -->
    <div
      style="
        flex: 0 1 45%;
        box-sizing: border-box;
        border: 1px solid #e8eaec;
        padding: 20px;
        border-radius: 4px;
      "
    >
      <h3 style="margin-bottom: 20px">对照组</h3>
      <div
        style="
          padding: 15px;
          background: #f8f8f9;
          border-radius: 4px;
          color: #515a6e;
        "
      >
        无弹窗推送
      </div>
    </div>

    <!-- 实验组列表 -->
    <div
      v-for="i in Array.from(
        { length: experimentGroupCount },
        (_, index) => index + 1
      )"
      :key="i"
      style="
        flex: 0 0 45%;
        box-sizing: border-box;
        border: 1px solid #e8eaec;
        padding: 20px;
        border-radius: 4px;
      "
    >
      <h3 style="margin-bottom: 20px">实验组 {{ i }}</h3>
      <div
        style="
          padding: 15px;
          background: #f8f8f9;
          border-radius: 4px;
          color: #515a6e;
        "
      >
        推送线上配置的弹窗
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupPushConfig',
  props: {
    // 表单数据
    formData: {
      type: Object,
      required: true
    },
    // 实验组数量
    experimentGroupCount: {
      type: Number,
      default: 1
    },
    // 是否禁用
    disabled: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="less"></style>
